import tmhRequest from "@/config/tmhRequest";

export default {
  searchStoreMemberConsumeTraceReportColumn: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/memberconsumetracereport/searchstorememberconsumetracereportcolumn",
      method: "post",
      data: data
    });
  },

  searchStoreMemberConsumeTraceReportCount: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/memberconsumetracereport/searchstorememberconsumetracereportcount",
      method: "post",
      data: data
    });
  },

  searchStoreMemberConsumeTraceReportByPage: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/memberconsumetracereport/searchstorememberconsumetracereportbypage",
      method: "post",
      data: data
    });
  },

  searchForAdviserMemberConsumeTraceReportColumn: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/memberconsumetracereport/searchforadvisermemberconsumetracereportcolumn",
      method: "post",
      data: data
    });
  },

  searchForAdviserMemberConsumeTraceReportCount: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/memberconsumetracereport/searchforadvisermemberconsumetracereportcount",
      method: "post",
      data: data
    });
  },

  searchForAdviserMemberConsumeTraceReportByPage: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/memberconsumetracereport/searchforadvisermemberconsumetracereportbypage",
      method: "post",
      data: data
    });
  },

  searchForAdviserDetailMemberConsumeTraceReportColumn: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/memberconsumetracereport/searchforadviserdetailmemberconsumetracereportcolumn",
      method: "post",
      data: data
    });
  },

  searchForAdviserDetailMemberConsumeTraceReportCount: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/memberconsumetracereport/searchforadviserdetailmemberconsumetracereportcount",
      method: "post",
      data: data
    });
  },

  searchForAdviserDetailMemberConsumeTraceReportByPage: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/memberconsumetracereport/searchforadviserdetailmemberconsumetracereportbypage",
      method: "post",
      data: data
    });
  },

  searchServiceAdviserMemberConsumeTraceReportColumn: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/memberconsumetracereport/searchserviceadvisermemberconsumetracereportcolumn",
      method: "post",
      data: data
    });
  },

  searchServiceAdviserMemberConsumeTraceReportCount: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/memberconsumetracereport/searchserviceadvisermemberconsumetracereportcount",
      method: "post",
      data: data
    });
  },

  searchServiceAdviserMemberConsumeTraceReportByPage: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/memberconsumetracereport/searchserviceadvisermemberconsumetracereportbypage",
      method: "post",
      data: data
    });
  },

  searchServiceBeauticianMemberConsumeTraceReportColumn: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/memberconsumetracereport/searchservicebeauticianmemberconsumetracereportcolumn",
      method: "post",
      data: data
    });
  },

  searchServiceBeauticianMemberConsumeTraceReportCount: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/memberconsumetracereport/searchservicebeauticianmemberconsumetracereportcount",
      method: "post",
      data: data
    });
  },

  searchServiceBeauticianMemberConsumeTraceReportByPage: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/memberconsumetracereport/searchservicebeauticianmemberconsumetracereportbypage",
      method: "post",
      data: data
    });
  },

  searchServiceBeauticianDetailMemberConsumeTraceReportColumn: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/memberconsumetracereport/searchservicebeauticiandetailmemberconsumetracereportcolumn",
      method: "post",
      data: data
    });
  },

  searchServiceBeauticianDetailMemberConsumeTraceReportCount: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/memberconsumetracereport/searchservicebeauticiandetailmemberconsumetracereportcount",
      method: "post",
      data: data
    });
  },

  searchServiceBeauticianDetailMemberConsumeTraceReportByPage: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/memberconsumetracereport/searchservicebeauticiandetailmemberconsumetracereportbypage",
      method: "post",
      data: data
    });
  },

  exportMemberConsumeTraceReport: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/memberconsumetracereport/exportmemberconsumetracereport",
      method: "post",
      responseType: "blob",
      data: data
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/ispa/report/memberconsumetracereport.js